import { defineApiActionTypes } from 'store/common/action-helpers';
const prefix = 'graphql/SlackAuthButton';

export const LOGIN_WITH_SLACK_CODE = defineApiActionTypes(`${prefix}/LOGIN_WITH_SLACK_CODE`);
